module.exports = __webpack_public_path__ + "static/media/icon_wanzheng.443bd806.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecAwarenrssSolution/icon_wanzheng.svg
// module id = 235
// module chunks = 0